'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ToolFormControl from 'DesignComponents/tool/ToolFormControl';
import FormControlWithErrors from 'DesignEditorsUI/components/customWidgetEditor/sidebar/FormControlWithErrors';
import UISelect from 'UIComponents/input/UISelect';
import UITextInput from 'UIComponents/input/UITextInput';
import CrmObjectProperty from 'ContentComponents/cmv2/fields/CrmObjectProperty';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import { CRM_OBJECT_PROPERTY } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { DEFAULT, OBJECT_TYPE, PLACEHOLDER } from 'DesignData/enums/CustomWidgetFieldAttributes';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';
import withDebouncedInput from 'DesignEditorsUI/components/shared/inputs/withDebouncedInput';
import * as CrmObjectsActions from 'ContentData/actions/CrmObjects';
import * as crmObjectsSelectors from 'ContentData/selectors/crmObjects';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

const DebouncedUITextInput = withDebouncedInput(UITextInput);

function makeMapStateToProps() {
  return (state, props) => {
    const objectType = props.field[OBJECT_TYPE];
    return {
      crmObjectTypeOptions: crmObjectsSelectors.getCrmObjectTypeOptions(state),
      crmObjectSchema: crmObjectsSelectors.getCrmObjectSchema(state, {
        objectType
      }),
      selectedCrmObjectType: crmObjectsSelectors.getSelectedCrmObjectType(state, {
        objectType
      })
    };
  };
}

const mapDispatchToProps = {
  fetchCrmObjectSchema: CrmObjectsActions.fetchCrmObjectSchema,
  fetchCrmObjectTypes: CrmObjectsActions.fetchCrmObjectTypes
};

class CrmObjectPropertyContentOptions extends Component {
  constructor(...args) {
    super(...args);

    this.onObjectTypeChange = e => {
      this.props.editField({
        [OBJECT_TYPE]: e.target.value,
        [DEFAULT]: {
          property: null
        }
      });
    };

    this.onPlaceholderChange = e => {
      this.props.editField({
        [PLACEHOLDER]: e.target.value
      });
    };

    this.onDefaultChange = value => {
      this.props.editField({
        [DEFAULT]: value
      });
    };
  }

  componentDidMount() {
    const {
      crmObjectSchema,
      fetchCrmObjectSchema,
      fetchCrmObjectTypes,
      field
    } = this.props;
    fetchCrmObjectTypes();
    const objectType = field[OBJECT_TYPE];

    if (objectType && !crmObjectSchema) {
      fetchCrmObjectSchema(objectType);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      crmObjectSchema,
      fetchCrmObjectSchema,
      field
    } = this.props;
    const objectType = field[OBJECT_TYPE];

    if (prevProps.field[OBJECT_TYPE] !== objectType && objectType && !crmObjectSchema) {
      fetchCrmObjectSchema(objectType);
    }
  }

  renderCRMObjectTypeSelect() {
    const {
      crmObjectTypeOptions,
      fieldErrors,
      readOnly,
      selectedCrmObjectType
    } = this.props;
    return /*#__PURE__*/_jsx(FormControlWithErrors, {
      errors: fieldErrors[OBJECT_TYPE],
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('crmobject.objectType.label')
      }),
      children: /*#__PURE__*/_jsx(SidebarInput, {
        inputComponent: UISelect,
        disabled: readOnly,
        onChange: this.onObjectTypeChange,
        options: crmObjectTypeOptions,
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('crmobject.objectType.placeholder')
        }),
        required: true,
        value: selectedCrmObjectType
      })
    });
  }

  renderPlaceholderInput() {
    const {
      field,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsx(ToolFormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('selectFields.placeholder.label')
      }),
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('selectFields.placeholder.tooltip')
      }),
      children: /*#__PURE__*/_jsx(SidebarInput, {
        inputComponent: DebouncedUITextInput,
        onChange: this.onPlaceholderChange,
        value: field[PLACEHOLDER],
        disabled: readOnly
      })
    });
  }

  render() {
    const {
      field,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [this.renderCRMObjectTypeSelect(), field[OBJECT_TYPE] && this.renderPlaceholderInput(), field[OBJECT_TYPE] && /*#__PURE__*/_jsx(ToolFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`defaultLabels.${CRM_OBJECT_PROPERTY}`)
        }),
        children: /*#__PURE__*/_jsx(SidebarInput, {
          inputComponent: CrmObjectProperty,
          object_type: field[OBJECT_TYPE],
          onFieldChange: this.onDefaultChange,
          placeholder: field[PLACEHOLDER],
          readOnly: readOnly,
          type: field.type,
          value: field[DEFAULT]
        })
      })]
    });
  }

}

CrmObjectPropertyContentOptions.propTypes = {
  crmObjectSchema: PropTypes.object,
  crmObjectTypeOptions: PropTypes.array.isRequired,
  editField: PropTypes.func.isRequired,
  fetchCrmObjectSchema: PropTypes.func.isRequired,
  fetchCrmObjectTypes: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  fieldErrors: PropTypes.object,
  readOnly: PropTypes.bool,
  selectedCrmObjectType: PropTypes.string
};
export default connect(makeMapStateToProps, mapDispatchToProps)(CrmObjectPropertyContentOptions);